import React, { useEffect } from "react";
import '../../StoreDashboard/style.css'
import ChatWindow from "../../../../components/Widgets/ChatBox/ChatWindow";

const MessagesPage = ({setActivePath}) => {
    useEffect(() => {
        setActivePath("Messages");
      }, [setActivePath]);


  return (
    <div className="outlet-container">
      <ChatWindow/>
    </div>
  )
}

export default MessagesPage
